<template>
  <v-container>
    <Spinner v-if="!isInitialized" />
    <router-view
      v-if="isInitialized"
      :loading="loading"
      :arter="arterFiltered"
      :allArter="allArter"
      @filter="onFilter"
      @search="onSearch"
    ></router-view>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Spinner from '../../components/shared/Spinner'

export default {
  name: 'ArterHome',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: false,
      isInitialized: false,
      omitGroups: [],
      search:'',
    }
  },
  computed: {
    ...mapGetters('arter', { allArter: 'getArray', meta: 'getMeta' }),
    arterFiltered() {
      const arter = this.allArter.filter(({ life_cat_id }) => !this.omitGroups.includes(life_cat_id))
      if(this.search){
        return this.allArter.filter(({ name_sve }) => name_sve.toLowerCase().includes(this.search.toLowerCase()))
      }
      return arter
    },
  },
  methods: {
    ...mapMutations('arter', { addFilter: 'ADD_FILTER', setOrder: 'SET_SORT' }),
    ...mapActions('arter', { getArter: 'readCollection', createArt: 'create' }),
    ...mapActions('arterFacts', { getArterFacts: 'readCollection' }),
    
    async fetch() {
      this.loading = true
      await this.getArterFacts()
      await this.getArter()
      this.loading = false
    },
  

    onFilter(omitGroups) {
      this.omitGroups = omitGroups
    },
    onSearch(val) {
      this.search = val
    },
  },
  async created() {
    this.addFilter({ key: 'pageSize', value: 9999 })
    this.setOrder({ key: 'title_sve', value: 'ASC' })
    await this.fetch()
    this.isInitialized = true
  },
}
</script>

<style lang="less" scoped></style>
